const getBackgroundColors = () => {
  return {
    lighterPrimary: {
      default: 'primary.50',
      _dark: 'primary.900',
    },
    lightPrimary: {
      default: 'primary.100',
      _dark: 'primary.800',
    },
    primary: {
      default: 'primary.500',
      _dark: 'primary.300',
    },
    darkPrimary: {
      default: 'primary.700',
      _dark: 'primary.200',
    },
    darkerPrimary: {
      default: 'primary.900',
      _dark: 'primary.100',
    },
  }
}

export default getBackgroundColors()
